<template>
  <vs-row>
    <vs-row v-for="(product, index) in assignedProducts" :key="`product_${index}`">
      <AssignedProductRow :product="product" />
    </vs-row>
  </vs-row>
</template>

<script>
import { defineComponent, PropType } from '@vue/composition-api'
import CatalogItemsLinkerStore from '@/store/catalogItemsLinker/catalogItemsLinker'
import AssignedProductRow from '@/views/components/socialStream/AssignedProductRow.vue'

export default defineComponent({
  name: 'AssignedProductsList',
  components: {
    AssignedProductRow,
  },
  props: {
  },
  data() {
    return {
      columnNames: [
        'catalogImport.catalogProductsList.id',
        'catalogImport.catalogProductsList.title',
        'catalogImport.catalogProductsList.image',
        'catalogImport.catalogProductsList.actions',
      ],
      opened: '',
    }
  },
  computed: {
    assignedProducts() {
      if(CatalogItemsLinkerStore.state.linkedProducts !== null){
        return  Object.values(CatalogItemsLinkerStore.state.linkedProducts)
      }else{
        return []
      }
    },
  },
  watch: {
  },
  methods: {
  },
})
</script>

<style scoped>

</style>

